export default "__VITE_ASSET__DCX4PTnO__"